import { Input } from "@/components/ui/Input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/Select"

export function NumberField({
  value,
  onChange,
  min,
  disabled,
  label
}: {
  value: number
  onChange: (n: number) => void
  min: number
  disabled: boolean
  label: string
}) {
  return (
    <Input
      type="number"
      min={min}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      disabled={disabled}
      aria-label={label}
      className="mx-1 inline-block w-16 text-center px-1"
    />
  )
}

export function SelectField({
  value,
  onChange,
  options,
  disabled,
  label
}: {
  value: number
  onChange: (n: number) => void
  options: { value: number; label: string }[]
  disabled: boolean
  label: string
}) {
  return (
    <Select value={String(value)} onValueChange={(v) => onChange(Number(v))} disabled={disabled}>
      <SelectTrigger className="mx-1 inline-flex w-52 align-middle" aria-label={label}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((opt) => (
          <SelectItem key={opt.value} value={String(opt.value)}>
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

export function CheckboxRow({
  checked,
  onChange,
  disabled,
  label
}: {
  checked: boolean
  onChange: (v: boolean) => void
  disabled: boolean
  label: string
}) {
  return (
    <label className="flex items-center gap-2 text-sm text-foreground">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="accent-primary"
      />
      {label}
    </label>
  )
}
